module.exports = __webpack_public_path__ + "6512fca9ff4dc029307018c17e4a2a9d.svg";